import React, {Component} from 'react';
import {
    valueHandlerDefault
} from "../FormDynamic/Utils/valueHandler";
import classNames from 'classnames';
import {Checkbox, FormControlLabel, MenuItem, TextField} from "@material-ui/core";
import MaterialSelect from "@material-ui/core/Select/Select";
import TypeSuggestions from "./assets/TypeSuggestions";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import TypeStringArray from "./assets/TypeStringArray";
import ColorPicker from "../../ColorPicker";
import Switch from "@material-ui/core/Switch";
import TypeAutoCompleteRemote from "./assets/TypeAutoCompleteRemote";
import FormDynamic from "../FormDynamic";

const styles = (theme) => ({
    textField: {
        marginLeft: 0,
        marginRight: theme.spacing(),
    },
    checkBoxLabel: {
        fontSize: '0.9rem',
    },
    labelPlacementStart: {
        margin: 0
    }
});


class FormField extends Component {


    typeString = (element, path) => {
        const {onChange, values} = this.props;
        let pathToValue = path ? path : element.name;
        return (
            <FormDynamic
                setValue={(value, path) => onChange({target: {value, name: element.name}}, path, false)}
                field={{
                    name: pathToValue,
                    type: 'string',
                    path: pathToValue,
                    multiLanguage: element.multiLanguage
                }}
                values={values}
                fieldStyles={{withoutStyles: true, fullWidth: true}}
            />
        )
    };

    typeCheckBox = (element, path) => {
        const {classes, values, onChange} = this.props;
        let value = valueHandlerDefault(values, path);
        return (
            element.label ? (
                <FormControlLabel classes={{label: classes.checkBoxLabel}} control={
                    <Checkbox
                        disabled={element.disabled}
                        size={"small"}
                        color={"primary"}
                        value={value || false}
                        checked={value || false}
                        name={element.name}
                        onChange={(event) => onChange(event, path, true)}
                    />
                }
                                  label={element.label}/>
            ) : (
                <Checkbox
                    disabled={element.disabled}
                    size={"small"}
                    color={"primary"}
                    value={value || false}
                    checked={value || false}
                    name={element.name}
                    onChange={(event) => onChange(event, path, true)}
                />
            )
        )
    };

    typeSwitch = (element, path) => {
        const {classes, values, onChange, defaultValue} = this.props;
        let value = valueHandlerDefault(values, path);
        let currentValue = value !== undefined ? value : defaultValue ? defaultValue : false;
        return (
            element.label ? (
                <FormControlLabel labelPlacement={"start"} classes={{
                    labelPlacementStart: classes.labelPlacementStart,
                    label: classes.checkBoxLabel
                }} control={
                    <Switch
                        disabled={element.disabled}
                        defaultChecked={defaultValue}
                        size={"small"}
                        color={"primary"}
                        value={currentValue || false}
                        checked={currentValue || false}
                        name={element.name}
                        onChange={(event) => onChange(event, path, true)}
                    />
                }
                                  label={element.label}/>
            ) : (
                <Switch
                    disabled={element.disabled}
                    size={"small"}
                    color={"primary"}
                    value={currentValue || false}
                    checked={currentValue || false}
                    name={element.name}
                    onChange={(event) => onChange(event, path, true)}
                />
            )
        )
    };

    typeNumber = (element, path) => {
        const {classes, onChange, values} = this.props;
        let value = valueHandlerDefault(values, path);
        return (
            <>
                <TextField
                    id={`${element.name}Props`}
                    className={classNames(`${classes.textField} form-table`, {
                        [`${classes.textField} form-table-disabled`]: element.disabled
                    })}
                    fullWidth={true}
                    variant="outlined"
                    autoComplete={"off"}
                    disabled={element.disabled}
                    onChange={(event) => onChange(event, path, false)}
                    margin='none'
                    type={"number"}
                    InputProps={{
                        min: 0,
                        style: {padding: 0}
                    }}
                    name={element.name}
                    value={value || ''}
                />
            </>
        )
    };

    typeSelect = (element, path) => {
        const {classes, onChange, values} = this.props;
        let simpleValue = '';
        let pathToValue = path ? path : element.name;
        simpleValue = valueHandlerDefault(values, pathToValue, simpleValue);
        // console.log(simpleValue, path)
        return (
            <>
                <MaterialSelect
                    disableUnderline
                    id={`${element.name}Props`}
                    className={`${classes.textField} form-screenDesigner`}
                    fullWidth={true}
                    onChange={(event) => onChange(event, path, false)}
                    disabled={element.disabled}
                    name={element.name}
                    value={simpleValue || ''}
                    inputProps={{
                        className: 'form-dynamic-bool',
                    }}
                >
                    {element.menu.map((item, index) => {
                        return (
                            <MenuItem style={{paddingTop: 2, paddingBottom: 2}} key={index} value={item.value}>
                                {item.label}
                            </MenuItem>
                        )
                    })}
                </MaterialSelect>
            </>
        )
    };

    typeSuggestions = (element) => {
        const {onChangeSuggestions, values} = this.props;
        return (
            <TypeSuggestions element={element} values={values} onChangeSuggestions={onChangeSuggestions}/>
        )
    };

    typeAutoComplete = (element, path) => {
        const {onChangeAutoComplete, values, options} = this.props;
        return (
            <TypeAutoCompleteRemote
                onChangeAutoComplete={onChangeAutoComplete}
                element={element}
                values={values}
                path={path}
                options={options}
            />
        )
    };

    typeStringArray = (element, path) => {
        let pathToValue = path ? path : element.name;
        const {onChangeStringArray, values} = this.props;
        return (<TypeStringArray onChange={onChangeStringArray} values={values} path={pathToValue} element={element}/>)
    };

    typeColorPicker = (element) => {
        const {onChangeStyleColor, values, path, pickerType} = this.props;
        return (
            <div>
                <ColorPicker onChange={onChangeStyleColor}
                             path={path}
                             values={values}
                             name={element.name}
                             pickerType={pickerType}
                             value={values[element.name]}/>
            </div>
        )
    };

    typeMultiValue = (element) => {
        const {classes, onChange, values} = this.props;
        return (
            <div
                style={{display: 'flex', flexDirection: 'row'}}>
                {element.fields.map((field, index) => {
                    return (
                        <TextField
                            key={index}
                            type='number'
                            autoComplete={"off"}
                            style={{marginTop: 5}}
                            onChange={onChange}
                            value={values[`${element.name}${field.value}`] || ''}
                            label={field.label}
                            name={`${element.name}${field.value}`}
                            className={`${classes.textField} form-table-multiValue`}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                style: {padding: 0}
                            }}
                            variant='outlined'
                        />
                    )

                })}
            </div>
        )
    };


    renderField = (element, path) => {
        return (
            <div>
                {(() => {
                    switch (element.type) {
                        case 'string': {
                            return this.typeString(element, path);
                        }
                        case 'number': {
                            return this.typeNumber(element, path);
                        }
                        case 'select': {
                            return this.typeSelect(element, path);
                        }
                        case 'suggestions': {
                            return this.typeSuggestions(element)
                        }
                        case 'stringArray': {
                            return this.typeStringArray(element, path)
                        }
                        case 'colorPicker': {
                            return this.typeColorPicker(element, path)
                        }
                        case 'multiValue': {
                            return this.typeMultiValue(element, path)
                        }
                        case 'checkbox': {
                            return this.typeCheckBox(element, path)
                        }
                        case 'switch': {
                            return this.typeSwitch(element, path)
                        }
                        case 'autocomplete': {
                            return this.typeAutoComplete(element, path)
                        }
                        default: {
                            return this.typeString(element, path);
                        }
                    }
                })()}
            </div>
        )
    };


    render() {
        const {field, path} = this.props;
        return (
            this.renderField(field, path)
        );
    }
}

FormField.propTypes = {
    field: PropTypes.object.isRequired,
    path: PropTypes.string,
    onChange: PropTypes.func,
    onChangeSuggestions: PropTypes.func,
    values: PropTypes.any.isRequired,
    defaultValue: PropTypes.any,
};

export default withStyles(styles)(FormField);